export default {
    computed: {
        isOrientation() {
            return this.$store.getters["app/visibleOrientationGide"];
        },
    },
}